import { MigrationSpec } from "../migration.models"

const LEGACY_CAMPAIGN_FEATURE_KEYS = [
  "campaign",
  "campaignWhatsApp",
  "campaignSms",
  "campaignEmail"
]

// Copied literally from LEGACY_CAMPAIGN_FEATURES_FILTER in api-v2's Customer/core/customer.constants.ts.
const LEGACY_CAMPAIGN_FEATURES_FILTER = {
  $or: [
    { "features.campaign": { $exists: true } },
    { "features.campaignWhatsApp": { $exists: true } },
    { "features.campaignSms": { $exists: true } },
    { "features.campaignEmail": { $exists: true } }
  ]
}

const preview = (doc: Record<string, unknown>) => {
  const features = { ...(doc.features as Record<string, unknown>) }
  if (features.campaign === true) {
    features.campaignEngineV2 = true
  }
  LEGACY_CAMPAIGN_FEATURE_KEYS.forEach((key) => delete features[key])
  return { ...doc, features }
}

const sampleFields = [
  "name",
  ...LEGACY_CAMPAIGN_FEATURE_KEYS.map((key) => `features.${key}`),
  "features.campaignEngineV2"
]

const description = {
  en:
    "Sets `features.campaignEngineV2: true` wherever `features.campaign` is true, then unsets " +
    "`campaign`, `campaignWhatsApp`, `campaignSms` and `campaignEmail`. `campaignEngineV2` is " +
    "the only campaign feature left.",
  tr:
    "`features.campaign` true olan her kayıtta `features.campaignEngineV2: true` yazar, ardından " +
    "`campaign`, `campaignWhatsApp`, `campaignSms` ve `campaignEmail` alanlarını siler. Geriye " +
    "kalan tek kampanya özelliği `campaignEngineV2`."
}

const deployFirst = {
  en:
    "Deploy api-v2, user-panel-v2 and admin-panel-v2 before running this: the old user panel " +
    "locks campaigns on `features.campaign`, so it would lock them for every tenant.",
  tr:
    "Çalıştırmadan önce api-v2, user-panel-v2 ve admin-panel-v2'yi deploy edin: eski kullanıcı " +
    "paneli kampanyaları `features.campaign` ile kilitler, yani her müşteri için kilitlerdi."
}

const engineV2 = {
  en:
    "A promoted plan's next campaigns start on engine v2 (WhatsApp Web stays on v1); campaigns " +
    "already sending keep their engine.",
  tr:
    "Yükseltilen planın sonraki kampanyaları engine v2'de başlar (WhatsApp Web v1'de kalır); " +
    "gönderimdeki kampanyalar mevcut motorunu korur."
}

export const legacyCampaignFeaturesCustomerProducts: MigrationSpec = {
  type: "DROP_LEGACY_CAMPAIGN_FEATURES_CUSTOMER_PRODUCTS",
  collection: "CustomerProducts",
  risk: "DESTRUCTIVE",
  title: {
    en: "Customer plans → campaignEngineV2 is the only campaign feature",
    tr: "Müşteri planları → tek kampanya özelliği campaignEngineV2"
  },
  description,
  affectedFilter: LEGACY_CAMPAIGN_FEATURES_FILTER,
  sampleFields: ["customer", ...sampleFields],
  preview,
  notes: [
    deployFirst,
    engineV2,
    {
      en: "Evicts the cached plan of every customer it touches.",
      tr: "Dokunduğu her müşterinin önbellekteki planını siler."
    }
  ]
}

export const legacyCampaignFeaturesProducts: MigrationSpec = {
  type: "DROP_LEGACY_CAMPAIGN_FEATURES_PRODUCTS",
  collection: "Products",
  risk: "DESTRUCTIVE",
  title: {
    en: "Plan catalogue → campaignEngineV2 is the only campaign feature",
    tr: "Plan kataloğu → tek kampanya özelliği campaignEngineV2"
  },
  description,
  affectedFilter: LEGACY_CAMPAIGN_FEATURES_FILTER,
  sampleFields,
  preview,
  notes: [
    deployFirst,
    {
      en: "Plans bought or changed after this run copy the catalogue's campaignEngineV2.",
      tr: "Bu çalıştırmadan sonra satın alınan veya değiştirilen planlar katalogdaki campaignEngineV2'yi kopyalar."
    }
  ]
}
